import { getCookie } from '@utiljs/cookie';

import { getEnv, ENV } from '@utils/getEnv';
import request from '@utils/axiosWrapper';
import * as Ids from '@utils/ids';

const currentEnv = getEnv();
const uuid = getCookie('_lxsdk_cuid');

let requestDomain = `${window.location.protocol}//brook-e.waimai.meituan.com`;
if (currentEnv === ENV.TEST) {
    requestDomain = 'http://brook.waimai.test.meituan.com';
} else if (currentEnv === ENV.STAGE) {
    requestDomain = 'https://brook.waimai.st.meituan.com';
}

/** PC订单指纹枚举 */
enum PC_ORDER_FINGERPRINT_ID {
    /** 新订单push消息到达PC端（仅门店在当前设备上开启自动接单时上报） */
    NEW_ORDER_PUSH_ARRIVE = 21800,
    /** PC收到新订单push后拉订单详情 */
    NEW_ORDER_DETAIL_AFTER_PUSH = 21900,
    /** PC轮询到新订单详情（仅门店在当前设备上开启自动接单时上报） */
    NEW_ORDER_POLLING_ARRIVE = 22100,
    /** PC订单打印 */
    PC_PRINT_ORDER = 40600,
}

/**
 * 上报订单指纹
 *
 * @param wmOrderViewId 订单ViewId
 * @param orderPoiId 订单所属门店ID
 * @param fingerprintId 要上报指纹ID 在http://b.monitor.waimai.sankuai.com/admin/fingerprint/category/list配置
 * @param nodeStatusCode 该节点是否成功 1代表失败，0代表成功
 * @param nodeJson 包含任意业务信息的JSON对象
 */
const reportOrderFingerprint = (
    wmOrderViewId: string,
    orderPoiId: string,
    fingerprintId: PC_ORDER_FINGERPRINT_ID,
    nodeStatusCode: 1 | 0,
    nodeJson: object = {},
) => {
    request.postAsFormSubmit(`${requestDomain}/api/order/fingerprint/m/record`, {
        wmPoiId: orderPoiId,
        acctId: Ids.getAcctId(),
        appType: 3,
        token: Ids.getToken(),
        data: JSON.stringify([
            {
                wmOrderViewIds: wmOrderViewId,
                fingerprintId,
                timestamp: new Date().getTime(),
                code: nodeStatusCode,
                uuid,
                utmMedium: '',
                nodeJson: JSON.stringify({
                    cookieAcctId: Ids.getAcctId(),
                    cookieWmPoiId: Ids.getWmPoiId(),
                    ...nodeJson,
                }),
            },
        ]),
    });
};

export { reportOrderFingerprint, PC_ORDER_FINGERPRINT_ID };
